// extracted by mini-css-extract-plugin
module.exports = {"error":"Input_error__1_Xrs","label":"Input_label__2u1qW"};